import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

/** An empty private-customer leasing configuration, the starting point of a new leasing offer. */
export function createEmptyLeasingBody(): SaveSaleVehicleLeasingBody {
  return {
    financialInstitutionCodeId: null,
    targetGroup: 'PRIVATE',
    primaryTargetGroup: null,
    validFrom: null,
    validTo: null,
    activeTerm: null,
    activeAnnualMileage: null,
    rateMatrixCells: [],
    commonParameters: {
      listPrice: null,
      vatRate: null,
      downPayment: null,
      excessMileageCost: null,
      underMileageCredit: null,
      vehicleTransferIncluded: false,
      vehicleTransferAmount: null,
      vehicleRegistrationIncluded: false,
      vehicleRegistrationAmount: null,
      vehicleDeliveryIncluded: false,
      vehicleDeliveryAmount: null,
      maintenanceMonthly: null,
      wearMonthly: null,
      maintenanceAndWearMonthly: null,
      vehicleTaxMonthly: null,
      liabilityInsuranceMonthly: null,
      liabilityInsuranceDeductible: null,
      comprehensiveInsuranceMonthly: null,
      comprehensiveInsuranceDeductible: null,
      tiresMonthly: null,
      inspectionMonthly: null,
      returnValueInsuranceMonthly: null,
      specialConditionCodes: [],
      tradeInPossible: false,
      internalNotes: null,
    },
  };
}
